import { Link, Outlet } from 'react-router-dom';
import { BrandHomeLink } from '@/design-system/brand/BrandHomeLink';
import { openCookiePreferences } from '@/services/privacy/cookieConsent';
import '@/features/site/site.css';

export const PublicDirectoryLayout = () => (
  <div className="landing-page">
    <a className="landing-skip" href="#conteudo">Pular para o conteúdo</a>
    <header className="landing-header">
      <div className="landing-container landing-header-inner">
        <BrandHomeLink className="landing-brand" size={19} />
        <nav className="landing-nav" aria-label="Navegação principal">
          <Link to="/strains">Variedades</Link>
          <Link to="/effects">Efeitos</Link>
          <Link to="/communities">Comunidades</Link>
          <Link to="/associations">Associações</Link>
          <Link to="/">Como funciona</Link>
        </nav>
        <div className="landing-header-actions">
          <Link className="landing-login" to="/auth/login">Entrar</Link>
          <Link className="landing-cta landing-cta-small" to="/auth/signup">Criar perfil</Link>
        </div>
      </div>
    </header>
    <main id="conteudo" className="landing-container public-directory-content"><Outlet /></main>
    <footer className="landing-footer landing-container">
      <BrandHomeLink size={16} />
      <div>
        <Link to="/legal">Termos e privacidade</Link>
        <button type="button" onClick={openCookiePreferences}>Cookies</button>
      </div>
    </footer>
  </div>
);
